export const esBackendMessages = {
  errors: {
    accountLocked: `La cuenta ha sido bloqueada temporalmente debido a varios intentos fallidos de inicio de sesión. Inténtalo de nuevo en {{remaining_time}} minutos.`,
    accountLockedAttemptsRemaining: `Correo electrónico o contraseña incorrectos. Quedan {{attempts_left_until_lock}} antes de que se bloquee la cuenta.`,
    accountLockedOneMoreAttempt: `Correo electrónico o contraseña incorrectos. Un intento fallido más bloqueará su cuenta durante 15 minutos.`,
    answerNotFound: `No se encontró respuesta para la pregunta: {{question_key}}.`,
    answerQuestionKeyInvalid: `question_key inválido. Debe tener el formato "question_1" a "question_8".`,
    appleIapInvalidJson: `Carga JSON inválida`,
    appleIapMissingSignedPayload: `signedPayload faltante`,
    appleIapWebhookProcessingFailed: `Error al procesar el webhook`,
    chatArchivalTaskFailed: `No se pudo encolar la tarea de archivo: {{error}}`,
    chatCeleryTestFailed: `No se pudieron encolar las tareas de prueba de Celery: {{error}}`,
    chatQueryTooLong: `La solicitud es demasiado larga para procesarla.`,
    chatRulesRefreshFailed: `Error al actualizar las reglas del chat: {{error}}`,
    chatSessionAlreadyClosed: `La sesión {{session_id}} ya está cerrada`,
    chatSessionCloseAllFailed: `No se pudieron cerrar las sesiones: {{error}}`,
    chatSessionCloseFailed: `No se pudo cerrar la sesión: {{error}}`,
    chatSessionGetActiveFailed: `No se pudieron obtener las sesiones activas: {{error}}`,
    chatSessionNotFound: `Sesión de chat no encontrada`,
    chatStreamError: `Ocurrió un error en el flujo del chat. Vuelve a intentarlo.`,
    decryptionFailed: `No se pudieron descifrar los datos almacenados. Contacta al soporte.`,
    encryptionServiceNotConfigured: `El servicio de cifrado no está configurado correctamente. Contacta al soporte.`,
    expiredProviderToken: `Su sesión de inicio de sesión con Google o Apple ha caducado. Inténtelo de nuevo.`,
    fileDocxExceedsSizeLimit: `El archivo DOCX supera el límite de tamaño.`,
    fileImageExceedsSizeLimit: `La imagen supera el límite de tamaño.`,
    fileImageTypeNotAllowed: `El tipo de imagen {{subtype}} no está permitido.`,
    fileInsufficientPermissions: `Permisos insuficientes.`,
    fileNotFound: `Archivo no encontrado.`,
    filePdfExceedsSizeLimit: `El PDF supera el límite de tamaño.`,
    fileReadFailed: `No se pudo leer el archivo: {{error}}.`,
    fileSizeExceedsLimit: `El tamaño del archivo supera el tamaño máximo permitido de {{max_files}} MB.`,
    fileTooManyFiles: `Demasiados archivos. El número máximo permitido por carga es {{max_size}}.`,
    fileTooManyFilesAttached: `Demasiados archivos adjuntos. El número máximo permitido por mensaje es {{max_files}}.`,
    fileTypeNotAllowed: `El tipo de archivo {{file_type}} no está permitido.`,
    fileUploadAzureFailed: `Error al subir el archivo a Azure`,
    fileUploadFailed: `Carga fallida: {{error}}`,
    googlePlayInvalidBase64Json: `Base64/JSON inválido: {{error}}`,
    googlePlayInvalidEnvelope: `Sobre inválido: {{error}}`,
    googlePlayMissingMessageIdOrData: `Falta messageId o los datos`,
    googlePlayMissingRequiredFields: `Faltan campos RTDN obligatorios`,
    googlePlayPackageNameRequired: `Se requiere el nombre del paquete`,
    googlePlayPackageNotAllowed: `El paquete {{package_name}} no está permitido`,
    googlePlayProcessingFailed: `Error en el procesamiento: {{error}}`,
    googlePlayProductIdRequired: `Se requiere la ID del producto en los detalles de la compra`,
    googlePlayPurchaseDetailsRequired: `Se requieren los detalles de la compra`,
    googlePlayPurchaseTokenRequired: `Se requiere el token de compra`,
    googlePlayPurchaseVerificationFailed: `Error al verificar la compra: {{message}}`,
    googlePlayPurchaseVerificationFailedUnexpected: `Error en la verificación de la compra debido a un error inesperado.`,
    googlePlayServiceConfigurationError: `Error de configuración del servicio de Google Play: {{error}}`,
    incorrectEmailOrPassword: `Correo electrónico o contraseña incorrectos.`,
    incorrectPassword: `Contraseña incorrecta.`,
    internalServerError: `Error interno del servidor.`,
    invalidProviderToken: `No se pudo verificar el inicio de sesión con Google o Apple. Inténtelo de nuevo.`,
    invalidRefreshToken: `Token de actualización no válido.`,
    invalidToken: `Token no válido.`,
    invalidTokenType: `Tipo de token no válido.`,
    notAuthenticated: `No autenticado.`,
    couldNotValidateCredentials: `No se han podido validar las credenciales.`,
    accountInactive: `La cuenta está inactiva o programada para eliminación.`,
    providerAuthFailed: `El inicio de sesión con tu proveedor ha fallado. Inténtalo de nuevo o usa tu correo electrónico y contraseña.`,
    unsupportedProvider: `Este proveedor de inicio de sesión no es compatible.`,
    linkingRequired: `Esta identidad social debe vincularse a una cuenta HARVN existente antes de continuar.`,
    accountLinkingFailed: `No hemos podido vincular esta identidad social a tu cuenta HARVN. Comprueba tus datos e inténtalo de nuevo.`,
    providerUnavailable: `El inicio de sesión social no está disponible temporalmente. Utiliza tu correo electrónico y contraseña.`,
    onboardingIncomplete: `Tu cuenta aún no está completamente configurada. Completa los pasos necesarios antes de continuar.`,
    accountCompletionNotRequired: `Tu cuenta ya está completa. Puedes seguir usando HARVN con normalidad.`,
    tokenExpired: `El token ha caducado.`,
    tokenRevoked: `El token ha sido revocado.`,
    tokenLimitExceeded: `Se ha superado el límite de tokens.`,
    debugTokenCheckFailed: `Error al verificar el token: {{error}}`,
    passwordResetEmailFailed: `No se pudo enviar el correo de restablecimiento. Inténtalo más tarde.`,
    passwordSameAsCurrent: `La nueva contraseña no puede ser igual a la actual`,
    passwordsDontMatch: `Las contraseñas no coinciden.`,
    questionnaireNotFound: `No se ha encontrado el cuestionario.`,
    rateLimitExceeded: `Límite de solicitudes superado: {{limit_str}}.`,
    assistantPromptNotFound: `Indicador del asistente no encontrado`,
    assistantPromptNotAuthorized: `No autorizado para acceder a este indicador`,
    assistantPromptNotAuthorizedToActivate: `No autorizado para activar este indicador`,
    assistantPromptNotAuthorizedToDelete: `No autorizado para eliminar este indicador`,
    assistantPromptNotAuthorizedToUpdate: `No autorizado para actualizar este indicador`,
    validationDateInvalid: `Formato de fecha no válido.`,
    validationEmailInvalid: `Formato de dirección de correo electrónico no válido.`,
    validationFieldRequired: `Campo obligatorio.`,
    validationGeneric: `Error de validación.`,
    validationInvalidValue: `Valor no válido.`,
    validationPasswordLength: `La contraseña debe tener entre 8 y 40 caracteres.`,
    validationStringTooLong: `El valor es demasiado largo.`,
    validationStringTooShort: `El valor es demasiado corto.`,
    validationTypeError: `Tipo no válido.`,
    validationValueOutOfRange: `El valor está fuera del rango permitido.`,
    rateLimitRetryAfter: `Se ha alcanzado el límite de solicitudes. Inténtalo de nuevo {{retry_after_formatted}}.`,
    subscriptionAdminPrivilegesRequired: `Se requieren privilegios de administrador.`,
    subscriptionAlreadyActive: `El usuario ya tiene una suscripción activa.`,
    subscriptionCancelled: `Su suscripción ha sido cancelada. Vuelva a suscribirse.`,
    subscriptionCancelFailed: `No se ha podido cancelar la suscripción.`,
    subscriptionCannotDowngrade: `Hay una suscripción activa — no es posible degradar el plan.`,
    subscriptionCannotSwitchToSamePlan: `No es posible cambiar al mismo plan de suscripción.`,
    subscriptionDaysAdvanceLimit: `No se puede avanzar más de 365 días a la vez.`,
    subscriptionDayConsumptionFreemiumOnly: `El consumo diario solo está disponible para usuarios de la versión de prueba freemium.`,
    subscriptionDaysMustBePositive: `Los días utilizados deben ser positivos.`,
    subscriptionFreemiumActivationFailed: `No se ha podido activar la suscripción de prueba gratuita.`,
    subscriptionFreemiumExpired: `La prueba gratuita ha caducado.`,
    subscriptionFreemiumTrialEnded: `Su prueba gratuita ha finalizado. Suscríbase.`,
    subscriptionFreemiumTokensExhausted: `Has utilizado todos los tokens de la prueba gratuita. Suscríbete para continuar.`,
    subscriptionExpired: `Su suscripción ha caducado. Vuelva a suscribirse.`,
    subscriptionInvalidPlanChoice: `Selección de plan no válida. Debes elegir un plan Mensual o Anual.`,
    subscriptionInvalidStatus: `Estado de suscripción no válido.`,
    subscriptionNoActiveSubscription: `No se ha encontrado ninguna suscripción activa.`,
    subscriptionNotEnoughTokensRemaining: `No quedan suficientes tokens.`,
    subscriptionPaymentConfigurationError: `Error en la configuración del pago. Contacta con soporte.`,
    subscriptionPaymentProcessingError: `Error al procesar el pago: {{error}}.`,
    subscriptionPeriodEnded: `Tu suscripción ha terminado. Vuelve a suscribirte.`,
    subscriptionStripeConfigurationError: `Error de configuración de Stripe: {{error}}.`,
    subscriptionStripeNotAvailable: `Stripe no disponible.`,
    subscriptionStripeNotConfigured: `Stripe no configurado`,
    subscriptionTrialNotInitialized: `La prueba gratuita no está iniciada.`,
    subscriptionUserAlreadyHasActiveSubscription: `El usuario ya tiene una suscripción activa.`,
    subscriptionNoStripeSubscriptionForBillingPortal: `El método de pago solo se puede actualizar para suscripciones activas. No se encontró ninguna suscripción activa.`,
    subscriptionNotFound: `Suscripción no encontrada.`,
    subscriptionTokensMustBePositive: `Los tokens utilizados deben ser positivos.`,
    subscriptionWebhookInvalidPayload: `Carga inválida`,
    subscriptionWebhookInvalidSignature: `Firma inválida`,
    subscriptionWebhookMissingSignature: `Falta la cabecera stripe-signature`,
    subscriptionWebhookSecretNotConfigured: `El secreto del webhook no está configurado`,
    tokenAlreadyUsed: `El token ya se ha utilizado.`,
    tokenNotFound: `No se ha encontrado el token.`,
    tooManyLoginAttempts: `Demasiados intentos de inicio de sesión. Inténtalo de nuevo en {{retry_after}} segundos. Queda {{attempts_left_until_lock}} antes de que la cuenta sea bloqueada.`,
    unexpectedError: `Se produjo un error inesperado. Inténtalo de nuevo más tarde.`,
    userAccountCreationFailed: `No se pudo crear la cuenta. Inténtalo de nuevo o inicia sesión si ya tienes una cuenta.`,
    userCannotDeleteSelf: `Los super users no pueden eliminar su propia cuenta.`,
    userDeletionFailed: `No se pudo programar la eliminación de la cuenta. Inténtalo más tarde.`,
    userEmailAlreadyVerified: `Correo electrónico ya verificado.`,
    userEmailExists: `No se puede actualizar el correo electrónico. Pruebe con otro.`,
    userEmailNotVerified: `Dirección de correo electrónico no verificada.`,
    userEmailUpdateFailed: `No se puede actualizar el correo electrónico. Pruebe con otro.`,
    userInactive: `Usuario inactivo.`,
    userInsufficientPrivileges: `El usuario no tiene suficientes privilegios.`,
    userNotAllowed: `Usuario no permitido.`,
    userNotFound: `Usuario no encontrado.`,
    userPrivacyNotAccepted: `Para crear una cuenta debes aceptar la Política de Privacidad.`,
    userTermsNotAccepted: `Para crear una cuenta debes aceptar los Términos de Servicio.`,
    userWithEmailNotFound: `No existe ningún usuario con este correo electrónico en el sistema. `,
    userWithIdNotFound: `No existe ningún usuario con este ID en el sistema.`,
    userWithUsernameNotFound: `No existe ningún usuario con este nombre de usuario en el sistema.`,
  },
  success: {
    accountScheduledForDeletion: `Tu cuenta ha sido programada para eliminación.`,
    fileDeleted: `Archivo eliminado correctamente`,
    fileUploaded: `Archivo subido correctamente a Azure Blob Storage`,
    fileUploadedToSession: `Archivo subido correctamente al almacenamiento de la sesión`,
    fileUploadUrlGenerated: `URL de carga generada correctamente`,
    loggedOut: `Cierre de sesión exitoso`,
    passwordRecoveryEmailSent: `Correo de recuperación de contraseña enviado`,
    passwordUpdated: `Contraseña actualizada correctamente`,
    sessionClosed: `Sesión {{session_id}} cerrada y puesta en cola para archivado`,
    userDeleted: `Usuario eliminado correctamente`,
    userVerified: `Usuario verificado correctamente`,
    verificationEmailSent: `Correo de verificación reenviado correctamente`,
  },
} as const;
